module.exports = __webpack_public_path__ + "img/user_02.8405e4b9.jpg";